module.exports = __webpack_public_path__ + "img/subject_05_106.jpg";